'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.submitReply = submitReply;
exports.getByUser = getByUser;
exports.resetStatusSuccess = resetStatusSuccess;

var _localStorage = require('../../utils/localStorage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'lookme/reviews/LOAD';
var LOAD_SUCCESS = 'lookme/reviews/LOAD_SUCCESS';
var LOAD_FAIL = 'lookme/reviews/LOAD_FAIL';
var POST = 'lookme/reviews/POST';
var POST_SUCCESS = 'lookme/reviews/POST_SUCCESS';
var POST_FAIL = 'lookme/reviews/POST_FAIL';
var REPLY = 'lookme/reviews/REPLY';
var REPLY_SUCCESS = 'lookme/reviews/REPLY_SUCCESS';
var REPLY_FAIL = 'lookme/reviews/REPLY_FAIL';
var GET_BY_USER = 'lookme/reviews/GET_BY_USER';
var GET_BY_USER_FAIL = 'lookme/reviews/GET_BY_USER_FAIL';
var GET_BY_USER_SUCCESS = 'lookme/reviews/GET_BY_USER_SUCCESS';
var RESET_STATUS_SUCCESS = 'lookme/reviews/RESET_STATUS_SUCCESS';
var initialState = {
  data: null,
  loadError: null,
  loaded: false,
  prominentLoaded: false,
  postCount: 0,
  media: [],
  reviews: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        retrieveByShop: action.result.reviews,
        totalRating: action.result.totalPoint,
        media: action.result.media,
        loadError: null,
        loaded: true
      });
    case LOAD_FAIL:
      {
        if (typeof action.error === 'string') {
          return (0, _extends3.default)({}, state, {
            loading: false,
            loadError: action.error,
            loaded: true
          });
        }
      }
    case POST:
      return (0, _extends3.default)({}, state, {
        posting: true
      });
    case POST_SUCCESS:
      return (0, _extends3.default)({}, state, {
        posting: false,
        success: true,
        postError: null,
        postCount: state.postCount + 1
      });
    case POST_FAIL:
      return (0, _extends3.default)({}, state, {
        posting: false,
        postError: action.error,
        success: true
      });
    case RESET_STATUS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        success: false
      });
    case REPLY:
      return (0, _extends3.default)({}, state, {
        replying: true
      });
    case REPLY_SUCCESS:
      return (0, _extends3.default)({}, state, {
        replying: false,
        success: true,
        replyError: null,
        postCount: state.postCount + 1
      });
    case REPLY_FAIL:
      return (0, _extends3.default)({}, state, {
        replying: false,
        replyError: action.error,
        success: true
      });
    case GET_BY_USER:
      return (0, _extends3.default)({}, state, {
        gettingByUser: true
      });
    case GET_BY_USER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        reviewsByuser: action.result,
        gettingByUser: false
      });
    case GET_BY_USER_FAIL:
      return (0, _extends3.default)({}, state, {
        gettingByUser: false,
        gettingError: action.error,
        success: true
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.reviews && globalState.reviews.loaded;
}

function submitReply(msg, reviewId) {
  var data = {
    message: msg,
    reviewId: reviewId,
    token: (0, _localStorage.localStore)().get('token')
  };
  return {
    types: [REPLY, REPLY_SUCCESS, REPLY_FAIL],
    promise: function promise(client) {
      return client.post('/review/reply', {
        data: data
      });
    }
  };
}

function getByUser(userId) {
  return {
    types: [GET_BY_USER, GET_BY_USER_SUCCESS, GET_BY_USER_FAIL],
    promise: function promise(client) {
      return client.get('/review/get-by-user/' + userId);
    }
  };
}

function resetStatusSuccess() {
  return {
    type: RESET_STATUS_SUCCESS
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/reviews.js
// module id = 730
// module chunks = 0